import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../../locale/useTranslation';
import ActionButton from '../../../framework/forms/helpercomponents/buttons/ActionButton';
import { ENTITYNAME, FILEURL, PUBLISH_REPORT, PUBLISH_REPORT_CONFIG, PUBLISH_TYPE, TOAST_TYPES } from '../../../framework/constant/constant';
import { utility } from '../../../framework/utility/utilityProvider';
import * as API from '../../../framework/API/api';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import BossDialog from '../../../components/BossDialog';
import { EditPageHeader } from '../../../components/EditPageHeader';
import ToastNotification from '../../../components/ToastNotification';

const ExportVodForm = (props) => {

    const { setShowExportForm, publishReport, setFooterMessage, isPopup = false } = props;

    const lang = useTranslation();
    // const defaultDates = utility.getFirstAndLastDateOfMonth();

    const [dataItem, setDataItem] = useState({
        // FromDate: defaultDates.FirstDate,
        // ToDate: defaultDates.LastDate,
        Catalogue: {},
        publishReport: {},
        VODType: {}
    });
    const [catalogues, setCatalogues] = useState([]);
    const [VODTypes, setVODTypes] = useState([])
    // when publish report is not passed from popup
    const [publishReportLocal, setPublishReportLocal] = useState([]);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let catalogueRes = await API.getData(ENTITYNAME.Catalogues, { sort: { Name: 1 }, query: ['Archive', '!=', true] });
        setCatalogues(catalogueRes.data);
        let VODTypeRes = await API.getData(ENTITYNAME.VODType, { sort: { Name: 1 }, query: ['Archive', '!=', true] });
        VODTypeRes.data.unshift({ _id: null, Name: "All" });
        setVODTypes(VODTypeRes.data);
        let vodReportType = PUBLISH_REPORT_CONFIG.filter(item => item.PUBLISH_TYPE == PUBLISH_TYPE.VODCatalogue);
        setPublishReportLocal(vodReportType);
        setDataItem({ ...dataItem, publishReport: utility.getDefaultItem(vodReportType), Catalogue: utility.getDefaultItem(catalogueRes.data), VODType: utility.getDefaultItem(VODTypeRes.data) });
    }
    console.log(publishReportLocal);

    const onChange = async (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    const isValid = () => {
        if (!isPopup && (!dataItem.publishReport || Object.keys(dataItem.publishReport).length == 0)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_report_type_error_message });
            return false;
        }
        if (!dataItem.Catalogue || Object.keys(dataItem.Catalogue).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_catalogue_error_message });
            return false;
        }
        if (!dataItem.VODType || Object.keys(dataItem.VODType).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_vod_type_error_message });
            return false;
        }
        // if (dataItem.FromDate == undefined || dataItem.FromDate.length == 0) {
        // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date});
        //     return false;
        // }

        // if (dataItem.ToDate == undefined || dataItem.ToDate.length == 0) {
        // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message});
        //     return false;
        // }

        // if (dataItem.FromDate > dataItem.ToDate) {
        // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.to_date_should_be_greater_than_from_date_error_message});
        //     return false;
        // }
        return true;
    }

    const handleExport = async () => {

        if (!isValid()) return;

        // Add footer message
        setFooterMessage(lang.please_wait_export_message);

        let payload = {
            Catalogue: dataItem.Catalogue,
            // FromDate: new Date(dataItem.FromDate + 'T00:00:00Z').getTime(),
            // ToDate: new Date(dataItem.ToDate + 'T23:59:59Z').getTime(),
            VODType: dataItem.VODType
        }

        let exportType = isPopup ? publishReport : dataItem?.publishReport?.SID;

        let res = await API.publishVodCatalogue(payload, exportType, true);
        console.log(res);
        if (res.success) {
            if (!res.data) {
                ToastNotification({ type: TOAST_TYPES.INFO, title: res?.messageTitle ?? "INFO", message: res.message });
                setFooterMessage(res.message);
                return;
            }
            ToastNotification({ type: TOAST_TYPES.INFO, title: res?.messageTitle ?? "INFO", message: res.message });
            setTimeout(async () => {

                window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
                setFooterMessage(lang.exported_successfully_message);
            }, 5000);
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            setFooterMessage(lang.report_is_not_exported_error_message);
        }
    }

    return (
        <>
            {isPopup && <EditPageHeader showTitle={false} saveButtonTitle={lang.export_button_text} onSubmit={handleExport} onCancel={() => setShowExportForm(false)} />}
            {!isPopup && <div style={{ display: "flex", justifyContent: "flex-start", marginLeft: "-10px", marginBottom: "10px" }}>
                <ActionButton
                    title={lang.publish_button_text}
                    name={lang.publish_button_text}
                    onClick={handleExport}
                />
            </div>}
            <div className="row mt-2">
                {!isPopup && <div className={"col-2 form-group"}>
                    <label>{lang.report_type_label}</label>
                    <DropDownList
                        data={publishReportLocal}
                        name="publishReport"
                        textField="Description"
                        dataItemKey="SID"
                        value={dataItem.publishReport}
                        onChange={onChange}
                    />
                </div>}
                <div className={`col-${isPopup ? "6" : "2"} form-group`}>
                    <label>{lang.catalogue_label} *</label>
                    <DropDownList
                        data={catalogues}
                        name="Catalogue"
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.Catalogue}
                        onChange={onChange}
                    />
                </div>
                <div className={`col-${isPopup ? "6" : "2"} form-group`}>
                    <label>{lang.vodtype_label} *</label>
                    <DropDownList
                        data={VODTypes}
                        name="VODType"
                        textField="Name"
                        dataItemKey="_id"
                        value={dataItem.VODType}
                        onChange={onChange}
                    />
                </div>
                {/* <div className={`col-${isPopup ? "6" : "2"} form-group`}>
                    <label>{lang.from_date_label} *</label>
                    <input
                        type="date"
                        className="form-control form-control-sm"
                        name="FromDate"
                        value={dataItem.FromDate || ''}
                        onChange={onChange}
                    />
                </div> */}
                {/* <div className={`col-${isPopup ? "6" : "2"} form-group`}>
                    <label>{lang.to_date_label} *</label>
                    <input
                        type="date"
                        className="form-control form-control-sm"
                        name="ToDate"
                        value={dataItem.ToDate || ''}
                        onChange={onChange}
                    />
                </div> */}
            </div>
        </>
    )
}

export default ExportVodForm